import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useBranchList } from "../api/branches";
import { useAuth } from "../auth/AuthContext";

export function usePlatformBranchFilter() {
  const { session } = useAuth();
  const isPlatformOwner = session?.user?.is_platform_owner === true;
  const [searchParams, setSearchParams] = useSearchParams();
  const branchList = useBranchList({ isActive: true });

  const branchFilter = isPlatformOwner ? (searchParams.get("branch_id") ?? "") : "";

  const setBranchFilter = useCallback(
    (branchId: string) => {
      if (!isPlatformOwner) return;
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (branchId) next.set("branch_id", branchId);
          else next.delete("branch_id");
          return next;
        },
        { replace: true },
      );
    },
    [isPlatformOwner, setSearchParams],
  );

  const effectiveBranchId = isPlatformOwner ? branchFilter : (session?.user?.branch_id ?? "");

  return {
    isPlatformOwner,
    branchFilter,
    effectiveBranchId,
    setBranchFilter,
    branches: branchList.data ?? [],
    branchesLoading: branchList.loading,
  };
}
